var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleinstagramicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_11393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C6.2692 28 0 21.7308 0 14C0 6.2692 6.2692 0 14 0C21.7308 0 28 6.2692 28 14C28 21.7308 21.7308 28 14 28Z",
    fill: "url(#paint0_linear_0_11393)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 6.1656C16.5504 6.1656 16.8528 6.174 17.8608 6.2216C18.7932 6.2636 19.3 6.4204 19.636 6.552C20.0812 6.7256 20.4004 6.9328 20.7336 7.266C21.0668 7.5992 21.274 7.9184 21.4476 8.3636C21.5792 8.6996 21.7332 9.2064 21.778 10.1388C21.8228 11.1468 21.834 11.4492 21.834 14C21.834 16.5508 21.8256 16.8532 21.778 17.8612C21.736 18.7936 21.5792 19.3004 21.4476 19.6364C21.274 20.0816 21.0668 20.4008 20.7336 20.734C20.4004 21.0672 20.0812 21.2744 19.636 21.448C19.3 21.5796 18.7932 21.7336 17.8608 21.7784C16.8528 21.8232 16.5504 21.8344 13.9996 21.8344C11.4488 21.8344 11.1464 21.826 10.1384 21.7784C9.20603 21.7364 8.69923 21.5796 8.36323 21.448C7.91803 21.2744 7.59883 21.0672 7.26563 20.734C6.93243 20.4008 6.72523 20.0816 6.55163 19.6364C6.42003 19.3004 6.26603 18.7936 6.22123 17.8612C6.17643 16.8532 6.16523 16.5508 6.16523 14C6.16523 11.4492 6.17363 11.1468 6.22123 10.1388C6.26323 9.2064 6.42003 8.6996 6.55163 8.3636C6.72523 7.9184 6.93243 7.5992 7.26563 7.266C7.59883 6.9328 7.91803 6.7256 8.36323 6.552C8.69923 6.4204 9.20603 6.2664 10.1384 6.2216C11.1464 6.174 11.4488 6.1656 13.9996 6.1656ZM13.9996 4.4436C11.404 4.4436 11.0792 4.4548 10.06 4.5024C9.04363 4.55 8.34923 4.7096 7.73883 4.9476C7.11163 5.1884 6.57683 5.516 6.04763 6.048C5.51563 6.58 5.19083 7.112 4.94443 7.742C4.70923 8.3496 4.54683 9.044 4.49923 10.0632C4.45163 11.0824 4.44043 11.4072 4.44043 14.0028C4.44043 16.5984 4.45163 16.9232 4.49923 17.9424C4.54683 18.9588 4.70643 19.6532 4.94443 20.2636C5.18803 20.888 5.51563 21.4228 6.04763 21.952C6.57963 22.484 7.11163 22.8088 7.74163 23.0552C8.34923 23.2904 9.04363 23.4528 10.0628 23.5004C11.082 23.548 11.4068 23.5592 14.0024 23.5592C16.598 23.5592 16.9228 23.548 17.942 23.5004C18.9584 23.4528 19.6528 23.2932 20.2632 23.0552C20.8876 22.8116 21.4224 22.484 21.9516 21.952C22.4836 21.42 22.8084 20.888 23.0548 20.258C23.29 19.6504 23.4524 18.956 23.5 17.9368C23.5476 16.9176 23.5588 16.5928 23.5588 13.9972C23.5588 11.4016 23.5476 11.0768 23.5 10.0576C23.4524 9.0412 23.2928 8.3468 23.0548 7.7364C22.8112 7.112 22.4836 6.5772 21.9516 6.048C21.4196 5.516 20.8876 5.1912 20.2576 4.9448C19.65 4.7096 18.9556 4.5472 17.9364 4.4996C16.92 4.4548 16.5952 4.4436 13.9996 4.4436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9992 9.09155C11.2888 9.09155 9.09082 11.2896 9.09082 14C9.09082 16.7104 11.2888 18.9084 13.9992 18.9084C16.7096 18.9084 18.9076 16.7104 18.9076 14C18.9076 11.2896 16.7096 9.09155 13.9992 9.09155ZM13.9992 17.1864C12.2408 17.1864 10.8128 15.7612 10.8128 14C10.8128 12.2388 12.2408 10.8136 13.9992 10.8136C15.7576 10.8136 17.1856 12.2388 17.1856 14C17.1856 15.7612 15.7576 17.1864 13.9992 17.1864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1011 10.0465C19.7351 10.0465 20.2491 9.53251 20.2491 8.89849C20.2491 8.26447 19.7351 7.75049 19.1011 7.75049C18.4671 7.75049 17.9531 8.26447 17.9531 8.89849C17.9531 9.53251 18.4671 10.0465 19.1011 10.0465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_11393",
    x1: 4.1005,
    y1: 23.8995,
    x2: 23.8995,
    y2: 4.1005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0551048,
    stopColor: "#FFD020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    stopColor: "#FEC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    stopColor: "#FCA71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    stopColor: "#FA8316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "#F85510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#F51E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F30005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    stopColor: "#F20007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    stopColor: "#E1003B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    stopColor: "#D30067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    stopColor: "#C70088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    stopColor: "#BF00A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    stopColor: "#BB00AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B900B4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleinstagramicon);
export default __webpack_public_path__ + "static/media/circleinstagramicon.1f4849151b17ad265d08f39be4a31b15.svg";
export { ForwardRef as ReactComponent };